import {
  UnsubscribeNewsletter,
  UNSUBSCRIBE_NEWSLETTER,
  ResetUnsubscribeNewsletter,
  RESET_UNSUBSCRIBE_NEWSLETTER,
} from "../types/newsletter/unsubscribe";

export const unsubscribeNewsletter = (payload: {
  email: string;
}): UnsubscribeNewsletter => {
  return { type: UNSUBSCRIBE_NEWSLETTER, payload };
};

export const resetUnsubscribeNewsletter = (): ResetUnsubscribeNewsletter => {
  return { type: RESET_UNSUBSCRIBE_NEWSLETTER, payload: null };
}; 